<template>
  <section class="dan_alix_hero">
    <div class="container">
      <div class="dan_alix_hero_content">
        <span class="dan_alix_hero_header" v-html="shopifyData.heading" />
        <img
          v-lazy="shopifyData.image"
          class="hero_img"
          :alt="shopifyData.image.alt || 'Hero Image'"
          loading="lazy"
          aria-hidden="true"
          aria-label="Hero Image"
          width=""
          height=""
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.dan_alix_hero {
  padding-top: 100px;
}
.container {
  max-width: 70%;
  width: 100%;
  margin: 0 auto;
}
.dan_alix_hero_header {
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  display: block;
  margin-bottom: 15px;
}
.hero_img {
  display: block;
}
@media only screen and (max-width: 768px) {
  .dan_alix_hero_header {
    font-size: 16px;
  }
}
</style>
